/**
 * スクロールアニメーション制御するjs
 */

/* eslint no-undef: ["error", { "typeof": true }] */

import { TweenMax, TimelineMax, Quad, Linear, Back } from 'gsap';
import ScrollMagic from 'scrollmagic';
import 'imports?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import Modernizr from 'modernizr';
import ua from '../util/ua';
import textSplit from '../util/textSplit';

const scrollAnimation = () => {
  const enable = !!(Modernizr.csstransforms);
  // if (ua('android')) {
  //   // enable = (androidVersion() <= 5);
  // }
  const controller = new ScrollMagic.Controller();
  const common = {
    tweenFrom: { autoAlpha: 0 },
    tweenTo: { autoAlpha: 1, ease: Quad.easeInOut, force3D: Modernizr.csstransforms3d },
    scene: { triggerHook: 0.78, reverse: true },
  };
  const perspective3d = { transformPerspective: 1000, perspective: 1000, transformStyle: 'preserve-3d', perspectiveOrigin: '50% 50%' };
  const slideIn = {
    tweenFrom: $.extend({}, common.tweenFrom, { y: 30 }),
    tweenTo: $.extend({}, common.tweenTo, { y: 0 }),
  };
  const animation = {

    intro() {},

    productHeaderIn() {
      const $productHD = $('.product-hd');
      const productHDTl = new TimelineMax();
      productHDTl
        .fromTo($('.product-hd-txt-atsusa'), 0.5,
          $.extend({}, common.tweenFrom, { y: -20, x: 20 }),
          $.extend({}, common.tweenTo, { y: 0, x: 0, ease: Back.easeInOut }))
        .fromTo($('.product-hd-txt-highspec'), 0.5,
          $.extend({}, common.tweenFrom, { y: 20, x: -20 }),
          $.extend({}, common.tweenTo, { y: 0, x: 0, ease: Back.easeInOut }),
          '-=0.4');
      $productHD.each((i, elem) => {
        if (elem) {
          new ScrollMagic.Scene($.extend({}, common.scene, { triggerElement: elem }))
            .setTween(productHDTl)
            .addTo(controller);
        }
      });
    },

    textSplitIn() {
      const $textSplitElement = $('.section-header');
      const textSplitArray = [];
      $textSplitElement.each((i, elem) => {
        if (elem) {
          const text = $(elem).find('span').text();
          const spanText = textSplit(text);
          $(elem).find('span').empty().append(spanText);
          TweenMax.set($(elem), $.extend({}, common.tweenFrom, { y: 20 }));
          TweenMax.set($(elem).find('small'), $.extend({}, common.tweenFrom, { y: -20 }));
          TweenMax.set($(elem).find('.split-text'), $.extend({}, common.tweenFrom, perspective3d, { z: 500 }));
          const tl = new TimelineMax()
            .to($(elem), 0.5, $.extend({}, common.tweenTo, { y: 0 }))
            .to($(elem).find('small'), 0.5, $.extend({}, common.tweenTo, { y: 0 }), '-=0.4')
            .staggerTo($(elem).find('.split-text'), 0.3, $.extend({}, common.tweenTo, { z: 0 }), 0.05, '-=0.4');
          textSplitArray[i] = new ScrollMagic
            .Scene($.extend({}, common.scene, { triggerElement: elem }))
            .setTween(tl)
            .addTo(controller);
        }
      });
    },

    slideIn() {
      const $slideElement = $('[data-slide-in]');
      const slide = [];
      TweenMax.set($slideElement, slideIn.tweenFrom);
      $slideElement.each((i, elem) => {
        if (elem) {
          const move = TweenMax
            .staggerFromTo($(elem), 0.5, slideIn.tweenFrom, slideIn.tweenTo, 0.08);
          slide[i] = new ScrollMagic.Scene($.extend({}, common.scene, { triggerElement: elem }))
            .setTween(move)
            .addTo(controller);
        }
      });
    },

    stagger() {
      const $staggerBlock = $('[data-stagger-block]');
      const $staggerElement = '[data-stagger]';
      const stagger = [];
      TweenMax.set($staggerElement, slideIn.tweenFrom);
      $staggerBlock.each((i, elem) => {
        if (elem) {
          const child = $(elem).find($staggerElement);
          const move = TweenMax.staggerFromTo(child, 0.5, slideIn.tweenFrom, slideIn.tweenTo, 0.08);
          stagger[i] = new ScrollMagic.Scene($.extend({}, common.scene, { triggerElement: elem }))
            .setTween(move)
            .addTo(controller);
        }
      });
    },

    parallax() {
      if (!ua('sp')) {
        const $parallax = $('[data-parallax]');
        $parallax.each((i, elem) => {
          if (elem) {
            new ScrollMagic
              .Scene({ triggerElement: elem, triggerHook: 'onEnter', duration: '200%' })
              .setTween($(elem).find('.parallax-pict'), { y: '-80%', ease: Linear.easeNone, force3D: Modernizr.csstransforms3d })
              .addTo(controller);
          }
        });
      }
    },

    bgParallax() {
      if (!ua('sp')) {
        const $bgParallax = $('[data-bg-parallax]');
        $bgParallax.each((i, elem) => {
          if (elem) {
            TweenMax.set(elem, { top: -500 });
            new ScrollMagic
              .Scene({ triggerElement: elem, triggerHook: 'onEnter' })
              .setTween(elem, { y: 500, ease: Linear.easeNone, force3D: Modernizr.csstransforms3d })
              .duration($(window).height() * 2).addTo(controller);
          }
        });
      }
    },

    kill() {
      TweenMax.killAll();
      // $('.content *').removeAttr('style');
    },

    load() {
      if (enable) {
        animation.textSplitIn();
        animation.slideIn();
        animation.stagger();
        animation.parallax();
        animation.bgParallax();
        animation.productHeaderIn();
      }
    },

    init() {
      animation.kill();
      animation.load();
    },
  };
  // if (!ua('sp')) {
  animation.init();
  // }
};

export default scrollAnimation;



// WEBPACK FOOTER //
// ./src/scripts/common/scrollAnimation.js